




















import Vue from 'vue';
import Validation from '../../mixins/validation';

export default Vue.extend({
	name: 'FieldRadioButton', 
	props: {
		name: String, 
		label: String, 
		value: {type: ('' as any)}, 
		rules: Array, 
		options: Array
	}, 
	components: {

	},
	data(): any {
		return {
			field: {
				value: null, 
				isValid: false
			}
		};
	}, 
    computed: {
		cols(): number {
			return this.options && this.options.length > 3 ? 3 : 4;
		},
        optionsArray(): Array<any> {
			if (this.options && this.options.length){
				if (typeof this.options[0] != 'object'){
					const options = this.options.map((option: any) => {
						return { label: option, value: option };
					})
					return options;
				} 
                else {
					return this.options;
				}
			}
			else {
				return [];
			}			
        }
    },
	methods: {
		handleFieldInput(): void {
			Validation.setFieldValid(this.field, this.rules);
			this.$emit('input', this.field.isValid ? this.field.value : '');
		}
	}, 
	mounted(): void {
		if (this.value){
			this.field.value = this.value;
			this.field.isValid = true;
		}
	}
});
